import { apiEndpoints } from '@/config/apiEndpoints';

import { post } from '@/services/http/client';
import {
  mapNewsletterPayloadToRequestDto,
  mapNewsletterSuccessResponse,
} from './Newsletter.mapper';

import type {
  NewsletterPayload,
  NewsletterRequestDto,
  NewsletterSuccessResponse,
} from './Newsletter.types';

export const subscribeToNewsletter = async (
  payload: NewsletterPayload,
): Promise<NewsletterSuccessResponse> => {
  const requestBody: NewsletterRequestDto = mapNewsletterPayloadToRequestDto(payload);

  const response = await post<NewsletterSuccessResponse>(apiEndpoints.newsletter, requestBody, {
    cache: 'no-store',
    timeoutMs: 10000,
  });

  return mapNewsletterSuccessResponse(response.data);
};
